module.exports = __webpack_public_path__ + "img/2a4b147b-31c2-4ded-a626-d7e209fb751b.e97c7feb.webp";